/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import { ACTION_TYPES } from '../actions/ActionTypes';

export const initialState = {
  loading: false,
  subjects: [],
  course: [],
  yearGroup: undefined,
  allStudents: [],
  groupListForDropDown: [],
  academicYearsList: []
  
 

}

const Common = (state = initialState, { type, payload }) => {
  switch(type){


    case ACTION_TYPES.FETCH_SUBJECTS:
      return { ...state, subjects: payload }
    case ACTION_TYPES.FETCH_COURSE:
      return { ...state, course: payload }
    case ACTION_TYPES.FETCH_YEARGROUP:
      return { ...state, yearGroup: payload } 
    case ACTION_TYPES.FETCH_ALL_STUDENTS:
      return { ...state, allStudents: payload } 
    case ACTION_TYPES.FETCH_GROUP:
      return { ...state, groupListForDropDown: payload } 
	case ACTION_TYPES.FETCH_ACADEMIC_YEAR:
	  return { ...state, academicYearsList: payload } 
      

      
 

      

    default:
      return { ...state }
  }
}

export default Common;